/**
 * Zeitraum-Auswahl-Logik für den Buchungskalender.
 */

export const parseDateInput = (value) => {
  if (!value) return null
  if (value instanceof Date) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate())
  }

  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (!match) return null

  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])
  const parsed = new Date(year, month - 1, day)
  if (Number.isNaN(parsed.getTime())) return null
  return parsed
}

export const formatDateInput = (date) => {
  if (!date) return ''
  const pad = (num) => String(num).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

export const isSameDay = (left, right) => {
  if (!left || !right) return false
  return left.getTime() === right.getTime()
}

/**
 * Standard-Zeitraum-Auswahl:
 * 1. Klick → Anreise
 * 2. Zweiter Klick → Abreise (wenn frei)
 * 3. Klick vor Anreise oder ungültiger Zeitraum → neue Anreise
 * 4. Beide gesetzt → nächster Klick startet neu
 */
export function resolveRangeClick({
  clickedDate,
  checkIn,
  checkOut,
  isRangeAvailable
}) {
  const clicked = new Date(
    clickedDate.getFullYear(),
    clickedDate.getMonth(),
    clickedDate.getDate()
  )
  const clickedValue = formatDateInput(clicked)
  const start = parseDateInput(checkIn)
  const end = parseDateInput(checkOut)

  if (!start || end) {
    return { checkIn: clickedValue, checkOut: '', message: '' }
  }

  if (clicked <= start) {
    return { checkIn: clickedValue, checkOut: '', message: '' }
  }

  if (isRangeAvailable(start, clicked)) {
    return { checkIn: checkIn, checkOut: clickedValue, message: '' }
  }

  return {
    checkIn: clickedValue,
    checkOut: '',
    message: 'Der gewählte Zeitraum ist leider nicht verfügbar. Bitte wählen Sie erneut.'
  }
}

export function isBetweenInclusiveHover(date, anchor, hover) {
  if (!anchor || !hover || hover <= anchor) return false

  const normalized = new Date(date.getFullYear(), date.getMonth(), date.getDate())
  return normalized > anchor && normalized <= hover
}
